export default __webpack_public_path__ + "static/39-0224956867cff777f4aeb654f0046135.png";